import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { fullNameSchema } from '../../../definitions/sharedSchema';
import {
  dobUI,
  fullNameUI,
  genderUI,
  vetRelationshipUI,
} from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-two-info-title--personal'];
const INPUT_LABEL = content['secondary-two-input-label'];
const HINT_TEXT = content['secondary-hint-label'];

const { fullName, date, gender, vetRelationship } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    secondaryTwoFullName: fullNameUI({
      label: INPUT_LABEL,
      labelAlt: HINT_TEXT,
    }),
    secondaryTwoDateOfBirth: dobUI(INPUT_LABEL),
    secondaryTwoGender: genderUI(INPUT_LABEL),
    secondaryTwoVetRelationship: vetRelationshipUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: [
      'secondaryTwoFullName',
      'secondaryTwoDateOfBirth',
      'secondaryTwoVetRelationship',
    ],
    properties: {
      secondaryTwoFullName: fullNameSchema(fullName),
      secondaryTwoDateOfBirth: date,
      secondaryTwoGender: gender,
      secondaryTwoVetRelationship: vetRelationship,
    },
  },
};
